<template>
  <div>
    <new-main-header v-if="hasNewLeftNavEnabled">
      Dashboard
    </new-main-header>
    <main-header v-else>
      <span slot="arrow-back">
        <el-tooltip
            class="item"
            effect="dark"
            content="Back to Start Page"
            placement="bottom-start">
          <router-link :to="{ name: 'HomePage' }"><i class="el-icon-back" /> </router-link>
        </el-tooltip>
      </span>
      <span slot="page-title">Dashboard</span>
    </main-header>
    <main-content>
      <div
          slot="main-content"
          class="grid gap_m dashboard-page">
        <!--ACCOUNT SUMMARY-->
        <new-account-summary />

        <!--DEVICES-->
        <device-table
            class="span-12"
            :customer-id="customer.id" />

        <!--THIRD PARTY DEVICES-->
        <third-party-devices-table
            class="span-12" />

        <!--CLIENT DEVICES-->
        <client-devices
            class="span-12 span-12-t"
            :customer="customer" />

        <!--CUSTOMER AUTHORIZATIONS-->
        <customer-authorizations
            class="span-12 span-12-t"
            :customer="customer" />

        <!--CELLULAR USAGE-->
        <cellular-usage-info
            v-if="customer.ring_devices"
            class="span-12 span-12-t"
            :customer="customer" />
      </div>
    </main-content>
  </div>
</template>

<script>
import MainHeader from "@/containers/Core/Header/MainHeader";
import MainContent from "@/containers/Core/MainContent";
import NewAccountSummary from "@/containers/Customer/NewAccountSummary";
import ClientDevices from "@/containers/Customer/Profile/ClientDevices";
import DeviceTable from "@/containers/Customer/Devices/DevicesTable";
import ThirdPartyDevicesTable from "@/containers/Customer/Devices/ThirdPartyDevicesTable";
import CustomerAuthorizations from "@/containers/Customer/Profile/CustomerAuthorizations";
import CellularUsageInfo from "@/containers/Customer/Profile/CellularUsageInfo";
import NewMainHeader from "@/NewUI/containers/core/header/MainHeader";

import { createNamespacedHelpers } from "vuex";
import permission from "@/mixins/permission";

const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");

const not = (x) => !x;

export default {
  name: "Dashboard",
  components: {
    MainHeader,
    MainContent,
    NewAccountSummary,
    ClientDevices,
    DeviceTable,
    ThirdPartyDevicesTable,
    CustomerAuthorizations,
    CellularUsageInfo,
    NewMainHeader,
  },
  mixins: [permission],
  data() {
    return {};
  },
  computed: {
    ...accountGetters(["customer", "email"]),
    hasNewLeftNavEnabled() {
      return this.hasPermission("NewUI", "leftNav");
    },
  },
  methods: {},
};
</script>

<style lang="scss">
@import "@/assets/scss/newui/fonts.scss";

.dashboard-page {
  overflow: auto;
  .el-card {
    margin-bottom: inherit;
  }

  // Client Device CSS modifications
  .el-table table th {
    text-transform: none;
    color: $--color-dusty-gray;
  }
  .el-table th,
  .el-table td {
    padding: 10px 10px;
  }
  .el-table.account-summary-locations {
    table {
      th {
        padding: 0px 10px 10px !important;
      }
    }
  }
}
</style>
